import { CustomCellRendererProps } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import { ReactElement, useMemo } from 'react';
import BadgeList from '../badge-list/BadgeList';
import { DocumentProduct } from '@cas/config/documents';

export function DocumentProductsCellRenderer({
  value,
}: CustomCellRendererProps<{ products: DocumentProduct[] }, DocumentProduct[]>): ReactElement {
  const { t } = useTranslation();

  const orderedItems = useMemo<string[]>(() => {
    if (Array.isArray(value)) {
      const translated: string[] = value.map(product => t('DocProduct.' + product));

      // Ensure in alphabetical order
      return translated.sort((a, b) => a[1].localeCompare(b[1]));
    }

    return [];
  }, [value, t]);

  return <BadgeList items={orderedItems} />;
}

export default DocumentProductsCellRenderer;
